import React from 'react'
import tinymce from 'tinymce/tinymce'
import { Editor } from '@tinymce/tinymce-react';
import FileManager from "components/filemanager/file-manager";
import { isImageFile } from './filemanager/filemanager-utils';

const language_maps = {
	'pt-pt': 'pt_PT',
	'de-de': 'de'
}

const globalConfig = {
	//theme: 'silver',
	license_key: 'gpl',
	skin: hp.style.getSelected() == 'dark' ? 'oxide-dark' : 'oxide',
	content_css: hp.style.getSelected(),
	plugins:
		//'image code link image table code'
		//'preview importcss searchreplace autolink autosave save directionality visualblocks visualchars fullscreen image link media codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons code',
		'preview importcss searchreplace autolink autosave save directionality visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount noneditable help charmap quickbars emoticons code',
	suffix: '.min',
	image_title: true,
	/* enable automatic uploads of images represented by blob or data URIs*/
	automatic_uploads: true,
	entity_encoding: 'raw',
	file_picker_types: 'image',
	branding: false,
	menubar: false,
	statusbar: false,
	toolbar: 'undo redo | bold italic underline strikethrough | blocks fontfamily fontsize | alignleft aligncenter alignright alignjustify |  numlist bullist | forecolor backcolor removeformat | image media audio fileManager | table | link anchor codesample | charmap emoticons | pagebreak | fullscreen  preview print | code',
	toolbar_mode: "sliding",
	quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
	contextmenu:  false, //'link image imagetools table configurepermanentpen',
	browser_spellcheck: true,
	tinycomments_mode: 'embedded',
	height: 500,
    convert_urls: false,
	file_picker_callback: (cb, value, meta) => {
		const el_picker = document.createElement('input');

		el_picker.setAttribute('type', 'file');
		el_picker.setAttribute('accept', 'image/*');
		el_picker.onchange = function(e) {
			const file = e.currentTarget.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				const id = 'blobid' + (new Date()).getTime();
				const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
				const base64 = reader.result.split(',')[1];
				const blobInfo = blobCache.create(id, file, base64);

				blobCache.add(blobInfo);

				/* call the callback and populate the Title field with the file name */
				cb(blobInfo.blobUri(), { title: file.name });
				//el_picker = null;
			};
			reader.readAsDataURL(file);
		};
		el_picker.click();
		el_picker.remove();
	},
}

tinymce.baseURL = hp.settings.tpldns + 'admin/tinymce/react'
if (hp.settings.locale) {
	globalConfig.language = language_maps[hp.settings.locale];
	globalConfig.language_url = tinymce.baseURL + '/langs/' + hp.settings.locale + '.js';
}

export default class HtmlEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state =  {
			selectedFiles: []
		}
		let { tags } = this.props

		this.config = Object.assign({}, globalConfig);
		if (tags) {
			this.config.toolbar =  globalConfig.toolbar + " | tags"
			this.config.init = (editor) => {
				editor.ui.registry.addMenuButton('tags', {
					text: 'Tags',
					fetch: function(callback) {
						const items = []
						tags = typeof tags === 'string' ? JSON.parse(tags) : tags
						for (const [key, label] of Object.entries(tags)) {
							items.push({type: 'menuitem', text: label, onAction: (e) => {
								editor.insertContent(key);
							}})
						}
						callback(items)
					},
					onAction: function(e) {
						editor.insertContent(this.value());
					}
				});
			}
		}
		this.currentContent = this.getValue();
	}

	handleEditorChange = (content, editor) => {
		if (!editor.hasFocus()) {
			return;
		}
		this.currentContent = content;

		if (this.props.model) {
			this.props.model[this.props.name] = content;
		}
		if (this.props.onChange) {
			this.props.onChange(content, this);
		}
	}

	getValue = () => this.props.initValue || (this.props.model ? this.props.model[this.props.name] : '') || '';

	addSelectedFileToHtml = (currentHtmlEditor, selectedFiles) => {
		selectedFiles = selectedFiles || this.state.selectedFiles;

		if (!currentHtmlEditor) {
			return;
		}
		selectedFiles.forEach(file => {
			if (!file) {
				return;
			}
			let content = `<a href="${file.url}" target="_blank">${file.url}</a>`;

			if(isImageFile(file)) {
				content = `<img src="${file.url}" alt="Imagem"/>`;
			}

			currentHtmlEditor.insertContent(content);
		});
		mbox.dismiss();
	}

	openFileManager = async (editor) => {
		FileManager.Modal(selectedFiles => this.setState({ selectedFiles }), () => this.addSelectedFileToHtml(editor));
	}

	onAddAudio = (currentHtmlEditor, selectedFiles) => {
		selectedFiles = selectedFiles || this.state.selectedFiles;

		if (!currentHtmlEditor) {
			return;
		}
		selectedFiles.forEach(file => {
			if (!file) {
				return;
			}
			let content = isImageFile(file)
				?	`<img src="${file.url}" alt="Imagem"/>`
				:	`<audio controls>
						<source src="${file.url}" type="audio/mpeg">
						Your browser does not support the audio element.
					</audio>`;
			currentHtmlEditor.insertContent(content);
		});
		mbox.dismiss();
	}

	addAudio = async (editor) => {
		FileManager.Modal(selectedFiles => this.setState({ selectedFiles, currentHtmlEditor: editor }), () => this.onAddAudio(editor));
	}

	render() {
		const { audio, autoFocus } = this.props;
		const config = Object.assign(this.config,
			{
				height: this.props.height || globalConfig.height,
				setup: (editor) => {
					editor.ui.registry.addButton('fileManager', {
						icon: 'upload',
						tooltip: 'Inserir ficheiros através do Explorador de Ficheiros',
						onAction: () => {
							this.openFileManager(editor);
						}
					});
					// plugin para inserir audio
					if (audio === undefined || audio) {
						editor.ui.registry.addButton('audio', {
							icon: 'audio',
							tooltip: 'Adicionar audio',
							onAction: () => {
								this.addAudio(editor);
							}
						});
						editor.ui.registry.addIcon('audio', `
							<svg width="24" height="24" viewBox="0 0 24 24">
								<path d="M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z"/>
							</svg>
						`);
					}
					if (this.config.init) {
						this.config.init(editor)
					}
					this.setState({activeEditor: editor})
				}
			},
			this.props.config || null
		)
		return (
			<Editor
				initialValue={this.getValue()}
				init={config}
				onInit={autoFocus ? (evt, editor) => editor.focus() : null}
				onEditorChange={this.handleEditorChange}
			/>
		);
	}

	static setSaved() {
		return tinymce.activeEditor ? tinymce.activeEditor.save() : null
	}

	componentDidUpdate(prevProps) {
		this.currentContent = this.getValue();
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.state !== nextState) {
			return true;
		}
		if (
			this.props.initValue !== nextProps.initValue ||
			this.props.height !== nextProps.height ||
			this.props.audio !== nextProps.audio ||
			this.props.autoFocus !== nextProps.autoFocus ||
			this.props.config !== nextProps.config ||
			this.props.tags !== nextProps.tags
		) {
			return true;
		}
		const nextVal = nextProps.initValue || (nextProps.model ? nextProps.model[nextProps.name] : '') || '';
		return nextVal !== this.currentContent;
	}
}
